import { Map, useMap } from "@vis.gl/react-google-maps";
import "./style.scss";
import { useEffect, useMemo, useRef, useState, useContext } from "react";
import TopNav from "ui/dashboard/topnav";
import { getAlertByGpt } from "../alerts/service";
import { showToast } from "ui/components/common";
import RightPanel from "./component/rightPanel";
import AlertCard from "./component/alertCard";
import PoiMarkers from "ui/map/poi-markers";
import React from "react";
import dayjs from "dayjs";
import { motion } from "motion/react";
import { AiThinkingIcon } from "./component/aiThinkingIcon";
import { getSiteCameras } from "pages/service";
import { Input, Select, Radio } from "antd";
import { ALERT_PROCESS_STATUS_SDK } from "lib/constants";
import AGI from "./component/agiWorkflow";
import { useNavigate, useParams } from "react-router-dom";
import {
  getSiteList,
  getVehicleList,
  getHeaderStats,
  getCaseByAlert,
} from "./service";
import { RelevanceOptions } from "ui/alerts/alerts-list";
import MagicSearchInput from "./component/magicSearchInput";
import HeaderStat from "./component/headerStat";
import { getCaseDetail } from "../cases/service";
import { set } from "date-fns";
import { AuthContext } from "context/AuthContext";
let lastRequest;
const tab1Name = "agi";
const tab2Name = "search";
export default function Page() {
  const navigate = useNavigate();
  const map = useMap();
  const { user } = useContext(AuthContext);
  const { tabname } = useParams();
  const [searchText, setSearchText] = useState("");
  const [alertList, setAlertList] = useState(null);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [alertTime, setAlertTime] = useState("allTime");
  const [alertLoading, setAlertLoading] = useState(false);
  const [cameraLocations, setCameraLocations] = useState([]);
  const [siteLocations, setSiteLocations] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [relevanceThreshold, setRelevanceThreshold] = useState(-1);
  const motionRef = useRef(null);
  const [locations, setLocations] = useState([]);

  const [vehicleSearchParams, setVehicleSearchParams] = useState<any>({});
  const [searchType, setSearchType] = useState("magic");
  const [activeCase, setActiveCase] = useState(null);
  const [flightPath, setFlightPath] = useState(null);
  useEffect(() => {
    setLocations([...cameraLocations, ...siteLocations]);
  }, [cameraLocations, siteLocations]);

  const animationType = useMemo(() => {
    if (collapsed) {
      return "collapsed";
    } else if (alertLoading) {
      return "loading";
    } else if (alertList?.length) {
      return "open";
    } else if (alertList?.length === 0) {
      return "loading";
    } else return "close";
  }, [alertList, alertLoading, collapsed]);
  function reset() {
    setCollapsed(false);
    setAlertLoading(false);
    setAlertList(null);
    setCameraLocations([]);
    setSelectedAlert(null);
    setRelevanceThreshold(-1);
    setActiveCase(null);
    if (flightPath) {
      flightPath.setMap(null);
      setFlightPath(null);
    }
  }
  function doSearch(_alertTime = null, _vehicleSearchParams: any = null) {
    if (_vehicleSearchParams === null) {
      _vehicleSearchParams = vehicleSearchParams;
    }
    const alertTimePrivate = _alertTime || alertTime;
    if (
      (searchType === "magic" || searchType === "magicV2") &&
      searchText === ""
    ) {
      reset();
      return;
    }
    if (
      searchType === "lpr" &&
      !_vehicleSearchParams.lpn &&
      !_vehicleSearchParams.brand &&
      !_vehicleSearchParams.color &&
      !_vehicleSearchParams.model
    ) {
      reset();
      return;
    }
    setAlertLoading(true);
    const abortController = new AbortController();

    setCollapsed(false);
    setAlertList(null);
    setCameraLocations([]);
    let filter = {};
    // modify search filter based on time period
    if (alertTimePrivate === "today") {
      filter = {
        startedAt: dayjs().startOf("day").valueOf(),
        endedAt: dayjs().endOf("day").valueOf(),
      };
    } else if (alertTimePrivate === "lastHour") {
      filter = {
        startedAt: dayjs().startOf("hour").valueOf(),
        endedAt: dayjs().endOf("hour").valueOf(),
      };
    }
    if (searchType === "magic" || searchType === "magicV2") {
      if (alertLoading && lastRequest) {
        lastRequest.abort();
      }
      lastRequest = getAlertByGpt(
        searchText,
        undefined,
        relevanceThreshold,
        true,
        filter,
        abortController,
        searchType,
      );
      lastRequest
        .then((data) => {
          if (data?.status === 200) {
            setAlertList(data.data.data);
            setAlertLoading(false);
            setCameraLocations(
              data.data.data.map((alert) => {
                if (alert.location.polygon.latitude) {
                  return {
                    key: alert.id,
                    location: {
                      lat: alert.location.polygon.latitude,
                      lng: alert.location.polygon.longitude,
                    },
                    type: "alert",
                    disableInfoWindow: true,
                  };
                }
              }),
            );
          } else if (data?.status && data?.status !== 200) {
            reset();
            showToast(1, "alert search failed");
          }
        })
        .catch((e) => {
          if (e.code !== "ERR_CANCELED") setAlertLoading(false);
        });
    } else {
      getVehicleList({ ..._vehicleSearchParams, ...filter })
        .then((data) => {
          if (data.status !== 200) {
            showToast(1, "Failed to get vehicle list, please try again later");
          } else {
            const alerts = data.data.alerts;
            const alertListwithCars = data.data.cars.map((item) => {
              const matchAlert = alerts[item.alertId];
              matchAlert.matchedVehicle = item.car;
              return matchAlert;
            });
            setAlertList(alertListwithCars);
            setCameraLocations(
              alertListwithCars
                .map((alert) => {
                  if (alert?.location?.polygon.latitude) {
                    return {
                      key: alert.id,
                      location: {
                        lat: alert.location.polygon.latitude,
                        lng: alert.location.polygon.longitude,
                      },
                      type: "alert",
                      disableInfoWindow: true,
                    };
                  } else return void 0;
                })
                .filter((item) => item),
            );
          }
        })
        .finally(() => setAlertLoading(false));
    }
  }
  useEffect(() => {
    doSearch();
  }, [alertTime, relevanceThreshold, searchType]);

  const onClickAlert = React.useCallback(
    async (poi) => {
      if (!map) {
        return;
      }
      console.log("onClickAlert", poi);
      if (poi.type === "alert") {
        const matchAlert = alertList?.find((alert) => alert.id === poi.key);
        if (matchAlert) {
          const ele = document.getElementById("alert_" + matchAlert.id);
          ele.scrollIntoView({ behavior: "smooth", block: "start" });
          setSelectedAlert(matchAlert);
        }
      } else {
        const siteId = poi.key;
        const location = siteLocations?.find((site) => site.key === siteId);
        map.setZoom(18);
        map.panTo(
          new google.maps.LatLng(location.location.lat, location.location.lng),
        );
        const data = await getSiteCameras(user.orgId, siteId);
        if (data?.status !== 200) {
          showToast(1, "Failed to get camera list, please try again later");
          return;
        }

        setCameraLocations(
          data.data.data
            .map((camera) => {
              if (!isNaN(camera?.cameraLocation?.latitude)) {
                return {
                  key: camera.id,
                  location: {
                    lat: camera.cameraLocation.latitude,
                    lng: camera.cameraLocation.longitude,
                    rotation: camera.cameraLocation.rotation,
                    type: camera.cameraLocation.type,
                    defaultSelected: false,
                  },
                  name: camera.name,
                  type: "camera",
                };
              }
            })
            .filter((item) => item),
        );
      }
    },
    [alertList, map, siteLocations],
  );
  // get case detail by alert
  async function doGetCaseByAlert() {
    if (selectedAlert.status !== ALERT_PROCESS_STATUS_SDK.Investigate) return;
    const res = await getCaseByAlert(selectedAlert.id);
    if (res.status !== 200) {
      showToast(1, "Failed to get case detail");
    } else {
      const caseData = res?.data?.data;
      const locations = [];
      caseData?.alerts?.sort((a, b) => +a.createdAt - +b.createdAt);
      caseData?.alerts.forEach((alert) => {
        if (alert?.location?.polygon.latitude) {
          locations.push({
            key: alert.id,
            location: {
              lat: alert.location.polygon.latitude,
              lng: alert.location.polygon.longitude,
            },
            type: "alert",
            disableInfoWindow: true,
          });
        }
      });
      if (locations.length) {
        // draw path between alerts and alert pins
        setLocations(locations);
        const flightPlanCoordinates = [];
        locations.forEach((location) => {
          flightPlanCoordinates.push({
            lat: location.location.lat,
            lng: location.location.lng,
          });
        });
        const _flightPath = new google.maps.Polyline({
          path: flightPlanCoordinates,
          geodesic: true,
          strokeColor: "#FF0000",
          strokeOpacity: 1.0,
          strokeWeight: 2,
        });
        if (map) {
          _flightPath.setMap(map);
          setFlightPath(_flightPath);
        }
      }
      setActiveCase(caseData);
    }
  }

  useEffect(() => {
    if (!map || !selectedAlert) {
      return;
    }
    setActiveCase(null);
    if (flightPath) {
      flightPath.setMap(null);
      setFlightPath(null);
    }
    doGetCaseByAlert();
    if (selectedAlert.location.polygon.latitude) {
      //show only current alert when selected
      setLocations([
        {
          key: selectedAlert.id,
          location: {
            lat: selectedAlert.location.polygon.latitude,
            lng: selectedAlert.location.polygon.longitude,
          },
          type: "alert",
          disableInfoWindow: true,
        },
      ]);
      map.panTo(
        new google.maps.LatLng(
          selectedAlert.location.polygon.latitude,
          selectedAlert.location.polygon.longitude,
        ),
      );
    }
    map.setZoom(19);
  }, [selectedAlert, map]);

  useEffect(() => {
    if (!map) return;
    getSiteList().then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to get site list, please try again later");
        return;
      }
      const sites = data.data.sites;

      const legalSites = sites.filter((site) => {
        console.log("site:", site);
        if (
          site?.details?.polygon.length > 0 &&
          !isNaN(+site.details.polygon[0].latitude) &&
          !isNaN(+site.details.polygon[0].longitude)
        ) {
          return true;
        } else if (
          site?.details?.geolocation?.length &&
          !isNaN(+site.details.geolocation[0].latitude) &&
          !isNaN(+site.details.geolocation[0].longitude)
        ) {
          return true;
        } else return false;
      });
      console.log("legalSites:", legalSites);

      const siteLocations = legalSites.map((site) => ({
        key: site.id.toString(),
        name: site.name,
        title: site.name,
        location: {
          lat: isNaN(site?.details?.geolocation?.[0]?.latitude)
            ? site.details.polygon?.[0]?.latitude
            : site.details.geolocation?.[0]?.latitude,
          lng: isNaN(+site?.details?.geolocation?.[0]?.longitude)
            ? site.details.polygon?.[0]?.longitude
            : site.details.geolocation?.[0]?.longitude,
        },
        type: site?.details?.geolocation?.[0]?.nvrType || "normal",
      }));
      setSiteLocations(siteLocations);
      const bounds = new google.maps.LatLngBounds();
      siteLocations.forEach((poi) => {
        if (!isNaN(+poi?.location?.lat) && !isNaN(+poi?.location?.lng)) {
          bounds.extend(
            new google.maps.LatLng(poi.location.lat, poi.location.lng),
          );
        }
      });
      map.fitBounds(bounds);
      map.panToBounds(bounds);
      if (siteLocations?.length === 1) {
        setTimeout(() => {
          map.setZoom(19);
        }, 1000);
      }
    });
  }, [map]);
  // change status of alert after click convert to case
  function onAlertStatusChange(alert) {
    doGetCaseByAlert();
    if (selectedAlert.id === alert.id) {
      setSelectedAlert((state) => ({
        ...state,
        status: ALERT_PROCESS_STATUS_SDK.Investigate,
      }));
    }
    setAlertList((alertList) => {
      return alertList?.map((item) => {
        if (item.id === alert.id) {
          item.status = ALERT_PROCESS_STATUS_SDK.Investigate;
          return item;
        } else return item;
      });
    });
  }

  if (!tabname) {
    navigate(`/dashboard/home/${tab2Name}`);
    return;
  }
  return (
    <>
      <TopNav title="Home">
        <HeaderStat />
        <Radio.Group
          buttonStyle="solid"
          value={tabname}
          onChange={(e) => {
            reset();
            navigate(`/dashboard/home/${e?.target?.value}`);
          }}
        >
          <Radio.Button value={tab2Name}>Search</Radio.Button>
          <Radio.Button value={tab1Name}>AGI</Radio.Button>
        </Radio.Group>
      </TopNav>
      <div className="flex h-full flex-col md:flex-row md:overflow-hidden bg-white rounded-3xl mr-6 mb-6 homePage">
        <div className="flex-grow relative flex">
          {tabname === tab2Name ? (
            <div style={{ position: "absolute", top: "18px", left: "18px" }}>
              <MagicSearchInput
                searchType={searchType}
                onSearchTypeChange={setSearchType}
                onAlertTimeChange={setAlertTime}
                doSearch={doSearch}
                searchText={searchText}
                onSearchTextChange={setSearchText}
                collapsed={collapsed}
                onCollapseChange={setCollapsed}
                vehicleSearchParams={vehicleSearchParams}
                onVehicleSearchParamsChange={setVehicleSearchParams}
              />
              <motion.div
                ref={motionRef}
                initial={false}
                animate={animationType}
                variants={{
                  collapsed: {
                    height: "60px",
                    clipPath: "inset(0px 25px 60px 355px round 11px)", //"inset(45% 2% 0% 89% round 10px)",
                    transition: {
                      type: "spring",
                      bounce: 0,
                      duration: 0.7,
                      delayChildren: 0.3,
                      staggerChildren: 0.05,
                    },
                  },
                  loading: {
                    height: "139px",
                    clipPath: "inset(0px 0px 0px 0px round 10px)",
                    transition: {
                      type: "spring",
                      bounce: 0,
                      duration: 0.7,
                      delayChildren: 0.3,
                      staggerChildren: 0.05,
                    },
                  },
                  open: {
                    height: "auto", //"calc(100vh - 255px)",

                    clipPath: "inset(0px 0px 0px 0px round 11px)",
                    transition: {
                      type: "spring",
                      bounce: 0,
                      duration: 0.7,
                      //delayChildren: 0.3,
                      staggerChildren: 0.05,
                    },
                  },
                  close: {
                    height: "auto",
                    clipPath: "inset(10% 50% 90% 50% round 10px)",
                    transition: {
                      type: "spring",
                      bounce: 0,
                      duration: 0.3,
                    },
                  },
                }}
                style={{
                  pointerEvents: "auto",
                  position: "relative",
                  zIndex: 1,
                  overflow: "hidden",
                  marginTop: "12px",
                }}
              >
                <div
                  style={{
                    height: "65px",
                    borderRadius: "16px 16px 0px 0px",
                    padding: "16px 0.5rem 16px 1.5rem",

                    backgroundColor: "white",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "white",
                      borderRadius: "0px 0px 16px 16px",
                      position: "relative",
                      maxHeight: "calc(100vh - 380px)",
                      overflowX: "hidden",
                      overflowY: "auto",
                      scrollSnapType: "y mandatory",
                    }}
                  >
                    Result
                  </span>
                  {(searchType === "magic" || searchType === "magicV2") && (
                    <span>
                      <Select
                        className="drawer-select"
                        popupClassName="select-dropdown relevance"
                        style={{ display: "inline-block", marginLeft: "8px" }}
                        dropdownStyle={{
                          borderRadius: "16px",
                          padding: "4px 0",
                        }}
                        value={relevanceThreshold}
                        onChange={(value) => setRelevanceThreshold(value)}
                        options={RelevanceOptions}
                      />
                    </span>
                  )}

                  <span style={{ float: "right" }}>
                    <button
                      style={{
                        display: "inline",
                        justifyItems: "center",
                        marginRight: "8px",
                        backgroundColor:
                          alertTime === "allTime"
                            ? "rgba(220, 231, 253, 1)"
                            : undefined,
                      }}
                      className="flex items-center rounded-xl hover:bg-zinc-200 border border-neutral-400  min-w-[64px] h-[33px]"
                      onClick={() => setAlertTime("allTime")}
                    >
                      <p className="text-sm font-semibold text-left">
                        All time
                      </p>
                    </button>
                    <button
                      style={{
                        display: "inline",
                        justifyItems: "center",
                        marginRight: "8px",
                        backgroundColor:
                          alertTime === "today"
                            ? "rgba(220, 231, 253, 1)"
                            : undefined,
                      }}
                      className="flex items-center rounded-xl hover:bg-zinc-200 border border-neutral-400  min-w-[64px] h-[33px]"
                      onClick={() => setAlertTime("today")}
                    >
                      <p className="text-sm font-semibold text-left">Today</p>
                    </button>
                  </span>
                </div>
                <div
                  style={{
                    backgroundColor: "white",
                    borderRadius: "0px 0px 16px 16px",
                    position: "relative",
                    maxHeight: "calc(100vh - 380px)",
                    overflowX: "hidden",
                    overflowY: "auto",
                    scrollSnapType: "y mandatory",
                  }}
                >
                  <>
                    {alertList?.length == 0 && (
                      <div style={{ textAlign: "center", padding: "1.5rem" }}>
                        No results matched with your search.
                      </div>
                    )}
                    {alertLoading && (
                      <div
                        style={{
                          placeItems: "center",
                          padding: "0px 0px 1.5rem 0px",
                        }}
                      >
                        <AiThinkingIcon />
                        {/* <LoadingOutlined /> */}
                      </div>
                    )}

                    {alertList?.map((alert) => {
                      return (
                        <AlertCard
                          key={alert.id}
                          alert={alert}
                          onSelectAlert={(alert) => {
                            setSelectedAlert(alert);
                          }}
                          active={alert.id === selectedAlert?.id}
                        />
                      );
                    })}
                  </>
                </div>
              </motion.div>
            </div>
          ) : (
            <AGI
              onSelectAlert={(alert) => {
                setSelectedAlert(alert);
              }}
              onInvestigated={onAlertStatusChange}
              selectedAlert={selectedAlert}
            />
          )}

          <Map
            mapTypeControlOptions={{
              style: 1,
              position: 10,
            }}
            defaultZoom={4}
            defaultCenter={{ lat: 37.0902, lng: -95.7129 }}
            mapId="a060739f521f7239"
            mapTypeId={"hybrid"}
          >
            <PoiMarkers
              pois={locations}
              onClickMarker={onClickAlert}
              hideCluster={true}
            />
          </Map>
          <RightPanel
            activeCase={activeCase}
            alert={selectedAlert}
            onAlertStatusChange={onAlertStatusChange}
          />
        </div>
      </div>
    </>
  );
}
